import React from 'react';
import PropTypes from 'prop-types';

import Banner from './Banner';
import { useBannerContext } from '../../common/contexts/BannerContext';
import { useAppContext } from '../../common/contexts/AppContext';

import { HOW_TO_ASSESS_MAZE_LINK } from '../../common/navigation/navigation';

const BMMazeBanner = ({ studentUid }) => {
    const bannerContext = useBannerContext();
    const { classId } = useAppContext();
    const {
        actions: { hideBMMazeBanner },
        isBannerVisible,
    } = bannerContext;

    const dismissHandler = () => hideBMMazeBanner({ classId, studentUid });

    const isBMMazeBannerVisible = isBannerVisible(classId, studentUid, 'isBMMazeBannerVisible');

    return isBMMazeBannerVisible ? (
        <Banner
            isInformation
            isDismissible
            dismissHandler={dismissHandler}
            className='dashboard-section dashboard-bm-section'
        >
            <div>
                <div className='dashboard-title'>Maze</div>
                <div className='dashboard-text'>
                    Maze is required for the composite score. Learn how to complete Maze online or
                    enter paper-pencil results&nbsp;
                    <a
                        className='dashboard-maze-link'
                        href={HOW_TO_ASSESS_MAZE_LINK}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        here <i className='dashboard-navigation-link-icon' />
                    </a>
                    .
                </div>
            </div>
        </Banner>
    ) : null;
};

BMMazeBanner.propTypes = {
    studentUid: PropTypes.string.isRequired,
};

export default BMMazeBanner;
